export default __webpack_public_path__ + "static/media/pietro.c0bd2f97.jpg";